import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e314791"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "skeleton-wrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skeleton-header-row" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Cliente"),
  /*#__PURE__*/_createElementVNode("span", null, "Vencimento"),
  /*#__PURE__*/_createElementVNode("span", null, "Status"),
  /*#__PURE__*/_createElementVNode("span", null, "Plano"),
  /*#__PURE__*/_createElementVNode("span", null, "Ações")
], -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Parceiro ")
const _hoisted_6 = { class: "action-buttons" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "show-keys-customer" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "show-keys-header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Chave do Cliente"),
  /*#__PURE__*/_createElementVNode("p", null, "Utilize a chave para acessar os recursos da API do cliente indicado")
], -1))
const _hoisted_11 = { class: "copy-key" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-key" }, "X-Client ID", -1))
const _hoisted_13 = { class: "copy-keys-obs" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("   Para sua segurança, evite compartilhar esses dados com outras pessoas! ")
const _hoisted_15 = { class: "lnk-docs-api" }
const _hoisted_16 = {
  href: "https://doc-api.certificata.com.br",
  target: "_blank"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode("   Consultar Documentação da API")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_skeleton_input = _resolveComponent("a-skeleton-input")!
  const _component_a_skeleton_button = _resolveComponent("a-skeleton-button")!
  const _component_a_skeleton_avatar = _resolveComponent("a-skeleton-avatar")!
  const _component_ShopOutlined = _resolveComponent("ShopOutlined")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_CrownOutlined = _resolveComponent("CrownOutlined")!
  const _component_SolutionOutlined = _resolveComponent("SolutionOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_KeyOutlined = _resolveComponent("KeyOutlined")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_CopyOutlined = _resolveComponent("CopyOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_InfoCircleOutlined = _resolveComponent("InfoCircleOutlined")!
  const _component_ReadOutlined = _resolveComponent("ReadOutlined")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoadingPartnerCustomers)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (n) => {
            return _createElementVNode("div", {
              class: "skeleton-row",
              key: n
            }, [
              _createVNode(_component_a_skeleton_input, {
                active: "",
                size: "small",
                class: "sk-col sk-col-name"
              }),
              _createVNode(_component_a_skeleton_input, {
                active: "",
                size: "small",
                class: "sk-col sk-col-date"
              }),
              _createVNode(_component_a_skeleton_button, {
                active: "",
                size: "small",
                class: "sk-col sk-col-status"
              }),
              _createVNode(_component_a_skeleton_input, {
                active: "",
                size: "small",
                class: "sk-col sk-col-plan"
              }),
              _createVNode(_component_a_skeleton_avatar, {
                active: "",
                size: "small",
                shape: "square",
                class: "sk-col-action"
              })
            ])
          }), 64))
        ]))
      : (_openBlock(), _createBlock(_component_a_table, {
          key: 1,
          size: "small",
          columns: _ctx.columns,
          "row-key": (record) => record.id,
          "data-source": _ctx.listPartnerCustomers,
          pagination: {
      current: _ctx.currentPage,
      pageSize: _ctx.pageSize,
      total: _ctx.total,
      showSizeChanger: false
    },
          "row-class-name": _ctx.rowClassName,
          onChange: _ctx.handleTablePartner,
          class: "datatable",
          locale: _ctx.customLocale,
          scroll: { y: 300 }
        }, {
          name: _withCtx(({ record }) => [
            (record.accountType === 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  _createVNode(_component_ShopOutlined)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createVNode(_component_UserOutlined)
                ])),
            _createTextVNode(" " + _toDisplayString(record.name) + " ", 1),
            (record.isPartner)
              ? (_openBlock(), _createBlock(_component_a_tag, {
                  key: 2,
                  color: "green",
                  class: _normalizeClass([
          'partner-tag',
          { 'partner-tag-highlight': record.id === _ctx.highlightId }
        ])
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 2
                }, 1032, ["class"]))
              : _createCommentVNode("", true)
          ]),
          status: _withCtx(({ record }) => [
            _createElementVNode("span", null, [
              _createVNode(_component_a_tag, {
                color: record.status === 'Pendente' ? 'geekblue' : record.status === 'Vencido' ? 'volcano' : 'green'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(record.status), 1)
                ]),
                _: 2
              }, 1032, ["color"])
            ])
          ]),
          action: _withCtx(({ record }) => [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.partnerHash === '991fe057-3f27-4822-9f15-0218eee908ea')
                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                    key: 0,
                    title: record.isPartner ? 'Ver dados da parceria' : 'Tornar parceiro'
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "action-btn",
                        onClick: ($event: any) => (record.isPartner ? _ctx.onViewPartner(record) : _ctx.onTurnPartner(record))
                      }, [
                        (!record.isPartner)
                          ? (_openBlock(), _createBlock(_component_CrownOutlined, { key: 0 }))
                          : (_openBlock(), _createBlock(_component_SolutionOutlined, { key: 1 }))
                      ], 8, _hoisted_7)
                    ]),
                    _: 2
                  }, 1032, ["title"]))
                : _createCommentVNode("", true),
              (_ctx.isFeatureApi)
                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                    key: 1,
                    title: "Chaves API"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "action-btn",
                        onClick: ($event: any) => (_ctx.showModalKeysPartnerCustomer(record, _ctx.partnerHash))
                      }, [
                        _createVNode(_component_KeyOutlined)
                      ], 8, _hoisted_8)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["columns", "row-key", "data-source", "pagination", "row-class-name", "onChange", "locale"])),
    _createVNode(_component_a_modal, {
      visible: _ctx.isShowKeysClient,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isShowKeysClient) = $event)),
      centered: "",
      footer: null,
      maskClosable: false,
      width: "1000px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("section", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_a_input_group, { compact: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.clientHash,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.clientHash) = $event)),
                  size: "large",
                  disabled: true,
                  class: "cp-key"
                }, null, 8, ["value"]),
                _createVNode(_component_a_tooltip, { title: "Copiar X-Client ID" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      size: "large",
                      onClick: _ctx.copyClientHash
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CopyOutlined)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("span", _hoisted_13, [
            _createVNode(_component_InfoCircleOutlined),
            _hoisted_14
          ]),
          _createElementVNode("span", _hoisted_15, [
            _createElementVNode("a", _hoisted_16, [
              _createVNode(_component_ReadOutlined),
              _hoisted_17
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}